// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnmn-btn{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:none;border-radius:4px;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:1em;padding:3px 10px;text-decoration:none;outline:none}.cnmn-btn:focus{-webkit-box-shadow:0 0 3px 1px rgba(0,0,255,.5);box-shadow:0 0 3px 1px rgba(0,0,255,.5)}.cnmn-btn::-moz-focus-inner{border:0}", ""]);
// Exports
module.exports = exports;
